import classNames from 'classnames';
import {defineMessages, injectIntl, intlShape} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import VM from 'scratch-vm';

import Box from '../box/box.jsx';
import Button from '../button/button.jsx';
import Controls from '../../containers/controls.jsx';
import {getStageDimensions} from '../../lib/screen-utils';
import {STAGE_SIZE_MODES, STAGE_NATIVE_SIZES} from '../../lib/layout-constants';

import fullScreenIcon from './icon--fullscreen.svg';
// import largeStageIcon from './icon--large-stage.svg';
// import smallStageIcon from './icon--small-stage.svg';
import unFullScreenIcon from './icon--unfullscreen.svg';
import settingsIcon from './icon--settings.svg';

import closeCoordinateIcon from './icon--close-coordinate.svg';
import openCoordinateIcon from './icon--open-coordinate.svg';

import zoonOutIcon from './icon--zoon-out.svg';
import zoonInIcon from './icon--zoon-in.svg';

import stageSizeIcon from './stageSize.svg';

import styles from './stage-header.css';

import FullscreenAPI from '../../lib/tw-fullscreen-api';

import Popover from 'react-popover';
import isEqual from 'lodash.isequal';

const messages = defineMessages({
    largeStageSizeMessage: {
        defaultMessage: 'Switch to large stage',
        description: 'Button to change stage size to large',
        id: 'gui.stageHeader.stageSizeLarge'
    },
    smallStageSizeMessage: {
        defaultMessage: 'Switch to small stage',
        description: 'Button to change stage size to small',
        id: 'gui.stageHeader.stageSizeSmall'
    },
    fullStageSizeMessage: {
        defaultMessage: 'Enter full screen mode',
        description: 'Button to change stage size to full screen',
        id: 'gui.stageHeader.stageSizeFull'
    },
    unFullStageSizeMessage: {
        defaultMessage: 'Exit full screen mode',
        description: 'Button to get out of full screen mode',
        id: 'gui.stageHeader.stageSizeUnFull'
    },
    fullscreenControl: {
        defaultMessage: 'Full Screen Control',
        description: 'Button to enter/exit full screen mode',
        id: 'gui.stageHeader.fullscreenControl'
    },
    openSettingsMessage: {
        defaultMessage: 'Open advanced settings',
        description: 'Button to open advanced settings in embeds',
        id: 'tw.openAdvanced'
    }
});

const enableSettingsButton = new URLSearchParams(location.search).has('settings-button');

const StageHeaderComponent = function (props) {
    const {
        customStageSize,
        isFullScreen,
        isPlayerOnly,
        onKeyPress,
        onSetStageLarge,
        onSetStageSmall,
        onSetStageFull,
        onSetStageUnFull,
        onOpenSettings,
        isEmbedded,
        stageSizeMode,
        vm,

        isShowCoordinate,
        onTriggerCoordinate,
        onZoomOutCoordinateFontSize,
        onZoomInCoordinateFontSize,

        onSetStageNativeSize,
        stageNativeSizePopoverOpen,
        onOpenStageNativeSizePopover,
        onCloseStageNativeSizePopover,
    } = props;

    let header = null;

    const stageNativeSizePopoverBody = (
        <div className={styles.stageNativeSize}>
            {
                STAGE_NATIVE_SIZES.map((item) => {
                    const {
                        width,
                        height,
                        title,
                    } = item;
                    const isCurSel = isEqual([customStageSize.width,customStageSize.height], [width, height]);
                    return (
                        <div
                            key={`key_${width}_${height}`}
                            className={classNames(
                                styles.stageNativeSizeButton,
                                {
                                    [styles['stageNativeSizeButton--sel']]: isCurSel,
                                }
                            )}
                            onClick={() => {
                                onSetStageNativeSize([width, height]);
                            }}
                        >
                            {title}
                        </div>
                    );
                })
            }
        </div>
    );

    if (isFullScreen || isEmbedded) {
        const stageDimensions = getStageDimensions(null, customStageSize, true);
        const settingsButton = isEmbedded && enableSettingsButton ? (
            <Button
                className={styles.stageButton}
                onClick={onOpenSettings}
            >
                <img
                    alt={props.intl.formatMessage(messages.openSettingsMessage)}
                    className={styles.stageButtonIcon}
                    draggable={false}
                    src={settingsIcon}
                    title={props.intl.formatMessage(messages.openSettingsMessage)}
                />
            </Button>
        ) : null;
        const fullscreenButton = isFullScreen ? (
            <Button
                className={styles.stageButton}
                onClick={onSetStageUnFull}
                onKeyPress={onKeyPress}
            >
                <img
                    alt={props.intl.formatMessage(messages.unFullStageSizeMessage)}
                    className={styles.stageButtonIcon}
                    draggable={false}
                    src={unFullScreenIcon}
                    title={props.intl.formatMessage(messages.fullscreenControl)}
                />
            </Button>
        ) : FullscreenAPI.available() ? (
            <Button
                className={styles.stageButton}
                onClick={onSetStageFull}
            >
                <img
                    alt={props.intl.formatMessage(messages.fullStageSizeMessage)}
                    className={styles.stageButtonIcon}
                    draggable={false}
                    src={fullScreenIcon}
                    title={props.intl.formatMessage(messages.fullscreenControl)}
                />
            </Button>
        ) : null;
        header = (
            <Box
                className={classNames(styles.stageHeaderWrapperOverlay, {
                    [styles.embedded]: isEmbedded
                })}
            >
                <Box
                    className={styles.stageMenuWrapper}
                    style={{width: stageDimensions.width}}
                >
                    <Controls vm={vm} />
                    <div className={styles.embedButtons}>
                        {settingsButton}
                        {fullscreenButton}
                    </div>
                </Box>
            </Box>
        );
    } else {
        const stageControls =
            isPlayerOnly ? (
                []
            ) : (
                <div className={styles.stageSizeToggleGroup}>
                    <div>
                    
                    <div className={styles.btn} >{isShowCoordinate ? (
                            <div className={styles.stageSizeToggleGroup}>
                                <Button
                                    className={classNames(
                                        styles.stageButton,
                                        styles.stageButtonFirst,
                                        (stageSizeMode === STAGE_SIZE_MODES.small) ? null : styles.stageButtonToggledOff
                                    )}
                                    onClick={onTriggerCoordinate}
                                >
                                    <img
                                        alt={props.intl.formatMessage(messages.smallStageSizeMessage)}
                                        className={styles.stageButtonIcon}
                                        draggable={false}
                                        src={closeCoordinateIcon}
                                    />
                                </Button>
                                <Button
                                className={classNames(
                                    styles.stageButton,
                                    styles.stageButtonMid,
                                    (stageSizeMode === STAGE_SIZE_MODES.small) ? null : styles.stageButtonOpenCoordinate
                                )}
                                onClick={onZoomOutCoordinateFontSize}
                            >
                                <img
                                    alt='缩小字体'
                                    className={styles.stageButtonIcon}
                                    draggable={false}
                                    src={zoonOutIcon}
                                />
                            </Button>
                            
                            <Button
                                className={classNames(
                                    styles.stageButton,
                                    styles.stageButtonLast,
                                    (stageSizeMode === STAGE_SIZE_MODES.small) ? null : styles.stageButtonOpenCoordinate
                                )}
                                onClick={onZoomInCoordinateFontSize}
                            >
                                <img
                                    alt='放大字体'
                                    className={styles.stageButtonIcon}
                                    draggable={false}
                                    src={zoonInIcon}
                                />
                            </Button>
                            </div>
                        ) : (
                            //'开启坐标'
                            <Button
                                className={classNames(
                                    styles.stageButton,
                                    (stageSizeMode === STAGE_SIZE_MODES.small) ? null : styles.stageButtonOpenCoordinate
                                )}
                                onClick={onTriggerCoordinate}
                            >
                                <img
                                    alt={props.intl.formatMessage(messages.smallStageSizeMessage)}
                                    className={styles.stageButtonIcon}
                                    draggable={false}
                                    src={openCoordinateIcon}
                                />
                            </Button>
                        )}</div>
                    </div>
                    <div>
                    <Popover
                        className="custom-popover"
                        body={stageNativeSizePopoverBody}
                        isOpen={stageNativeSizePopoverOpen}
                        preferPlace="below"
                        onOuterAction={onCloseStageNativeSizePopover}
                    >
                        <div>
                            <Button
                                className={styles.stageButton}
                                onClick={onOpenStageNativeSizePopover}
                            >
                                <img
                                    className={styles.stageButtonIcon}
                                    draggable={false}
                                    src={stageSizeIcon}
                                />
                            </Button>
                        </div>
                    </Popover>
                    </div>
                    {/* 隐藏放大缩小
                    <div>
                        <Button
                            className={classNames(
                                styles.stageButton,
                                styles.stageButtonFirst,
                                (stageSizeMode === STAGE_SIZE_MODES.small) ? null : styles.stageButtonToggledOff
                            )}
                            onClick={onSetStageSmall}
                        >
                            <img
                                alt={props.intl.formatMessage(messages.smallStageSizeMessage)}
                                className={styles.stageButtonIcon}
                                draggable={false}
                                src={smallStageIcon}
                            />
                        </Button>
                    </div>
                    <div>
                        <Button
                            className={classNames(
                                styles.stageButton,
                                styles.stageButtonLast,
                                (stageSizeMode === STAGE_SIZE_MODES.large) ? null : styles.stageButtonToggledOff
                            )}
                            onClick={onSetStageLarge}
                        >
                            <img
                                alt={props.intl.formatMessage(messages.largeStageSizeMessage)}
                                className={styles.stageButtonIcon}
                                draggable={false}
                                src={largeStageIcon}
                            />
                        </Button>
                    </div> */}
                </div>
            );
        header = (
            <Box className={styles.stageHeaderWrapper}>
                <Box className={styles.stageMenuWrapper}>
                    <Controls
                        vm={vm}
                        isSmall={stageSizeMode === STAGE_SIZE_MODES.small}
                    />
                    <div className={styles.stageSizeRow}>
                        {stageControls}
                        <div>
                            <Button
                                className={styles.stageButton}
                                onClick={onSetStageFull}
                            >
                                <img
                                    alt={props.intl.formatMessage(messages.fullStageSizeMessage)}
                                    className={styles.stageButtonIcon}
                                    draggable={false}
                                    src={fullScreenIcon}
                                    title={props.intl.formatMessage(messages.fullscreenControl)}
                                />
                            </Button>
                        </div>
                    </div>
                </Box>
            </Box>
        );
    }

    return header;
};

const mapStateToProps = state => ({
    customStageSize: state.scratchGui.customStageSize,
    // This is the button's mode, as opposed to the actual current state
    stageSizeMode: state.scratchGui.stageSize.stageSize
});

StageHeaderComponent.propTypes = {
    intl: intlShape,
    customStageSize: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number
    }),
    isFullScreen: PropTypes.bool.isRequired,
    isPlayerOnly: PropTypes.bool.isRequired,
    onKeyPress: PropTypes.func.isRequired,
    onSetStageFull: PropTypes.func.isRequired,
    onSetStageLarge: PropTypes.func.isRequired,
    onSetStageSmall: PropTypes.func.isRequired,
    onSetStageUnFull: PropTypes.func.isRequired,
    onOpenSettings: PropTypes.func.isRequired,
    isEmbedded: PropTypes.bool.isRequired,
    stageSizeMode: PropTypes.oneOf(Object.keys(STAGE_SIZE_MODES)),
    vm: PropTypes.instanceOf(VM).isRequired,

    isShowCoordinate: PropTypes.bool.isRequired, // 标识是否显示网格坐标
    onTriggerCoordinate: PropTypes.func.isRequired, // 控制是否显示网格坐标
    onZoomOutCoordinateFontSize: PropTypes.func.isRequired, // 缩小网格坐标系的字体大小
    onZoomInCoordinateFontSize: PropTypes.func.isRequired, // 放大网格坐标系的字体大小

    stageNativeSizePopoverOpen: PropTypes.bool.isRequired, // 用来控制 stageNativeSize 的 Popover 组件是否显示
    onOpenStageNativeSizePopover: PropTypes.func.isRequired, // 打开 stageNativeSize 的 Popover 组件
    onCloseStageNativeSizePopover: PropTypes.func.isRequired, // 关闭 stageNativeSize 的 Popover 组件
};

StageHeaderComponent.defaultProps = {
    stageSizeMode: STAGE_SIZE_MODES.large
};

export default injectIntl(connect(
    mapStateToProps
)(StageHeaderComponent));
